import { LucidAuthAPI } from '~api/api';

import { UUID_PATTERN } from '~constants/validation_patterns';

export const listIdentityProviders = (q, offset = 0, count = 50) => {
  const params = {
    count,
    offset
  };

  if (q) {
    params.filter = UUID_PATTERN.test(q) ? `id:eq:${q}` : `name:ilike:%${q}%`;
  }

  return LucidAuthAPI().get('idp', { params });
};

export const getIdentityProvider = (idpId) => {
  return LucidAuthAPI().get(`idp/${idpId}`);
};

export const createIdentityProvider = (idp) => {
  return LucidAuthAPI().post('idp/', idp);
};

export const updateIdentityProvider = (idpId, idpData) => {
  return LucidAuthAPI().patch(`idp/${idpId}`, idpData);
};

export const deleteIdentityProvider = (idpId) => {
  return LucidAuthAPI().delete(`idp/${idpId}`);
};

export const generateIdentityProviderURL = (idpId, urlData) => {
  return LucidAuthAPI().post(`idp/${idpId}/url`, urlData);
};
